export const allowedImageTypes = ["image/png", "image/jpg", "image/jpeg"];